module.exports = __webpack_public_path__ + "static/media/september.b94851b7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/september.jpeg
// module id = 296
// module chunks = 0